__turbopack_context__.v({
  "editQuestionWrapper": "Questions-module-scss-module__gQujVG__editQuestionWrapper",
});
